import { create } from "zustand";
import { useEffect } from "react";
import profileService from "../services/profileService"; // Ensure this exists

const useProfileStore = create((set, get) => ({
  profiles: [],
  fetchProfiles: async () => {
    try {
      // console.log("Fetching profiles..."); // Debug log
      const response = await profileService.getProfiles(); // API call

      set({ profiles: response.Data }); // Update Zustand store
    } catch (error) {
      console.error("Error fetching profiles:", error);
    }
  },
}));

// Automatically fetch profiles when app loads
export const useProfileInit = () => {
  const { profiles, fetchProfiles } = useProfileStore();

  useEffect(() => {
    if (profiles.length === 0) {
      fetchProfiles();
    }
  }, [fetchProfiles, profiles]); // Dependency on profiles
};

export default useProfileStore;
